// extracted by css-extract-rspack-plugin
export default {"icon":"DeleteColumn__icon--F8QK_","attention":"DeleteColumn__attention--CwSY9"};